import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import {
  Avatar,
  CssBaseline,
  Link,
  Paper,
  Box,
  Grid,
  Typography,
  makeStyles,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@material-ui/core";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import { useFirebase } from "../../Firebase/FirebaseContext";
import FinalForm from "../Elements/FinalForm";
import InputText from "../Inputs/InputText";
import CustomButton from "../Buttons/CustomButton";
import {
  browserLocalPersistence,
  setPersistence,
  createUserWithEmailAndPassword,
} from "firebase/auth";
import { collection, doc, setDoc, getDocs } from "firebase/firestore";

const useStyles = makeStyles((theme) => ({
  container: {
    maxWidth: 600,
    margin: "0 auto",
    padding: theme.spacing(4),
  },
  header: {
    marginBottom: theme.spacing(4),
    textAlign: "center",
  },
  avatar: {
    margin: "0 auto",
    marginBottom: theme.spacing(2),
    width: theme.spacing(8),
    height: theme.spacing(8),
    backgroundColor: theme.palette.primary.main,
    boxShadow: `0 4px 14px 0 ${theme.palette.primary.main}44`,
  },
  title: {
    fontWeight: 700,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(1),
  },
  subtitle: {
    color: theme.palette.text.secondary,
  },
  card: {
    padding: theme.spacing(4),
    borderRadius: 20,
    border: `1px solid ${theme.palette.divider}`,
  },
  form: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
  },
  submit: {
    marginTop: theme.spacing(2),
    height: 48,
    fontSize: "1rem",
    fontWeight: 600,
  },
  select: {
    width: "100%",
  },
  footer: {
    marginTop: theme.spacing(4),
    textAlign: "center",
  },
}));

export default function Signup() {
  const { firebase } = useFirebase();
  const history = useHistory();
  const classes = useStyles();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [status, setStatus] = useState("");
  const [belongsTo, setBelongsTo] = useState("");
  const [currentUser, setCurrentUser] = useState(null);

  const onSubmit = async (values) => {
    console.log(values);
    setPersistence(firebase.auth, browserLocalPersistence).then(() => {
      createUserWithEmailAndPassword(
        firebase.auth,
        values.email,
        values.password
      )
        .then((userCredential) => {
          //const uid = userCredential.user.uid;
          const userRef = doc(firebase.db, "users", values.email);
          setDoc(userRef, {
            firstName: values.firstName,
            lastName: values.lastName,
            name: values.firstName,
            email: values.email,
            status,
            belongs_to: doc(firebase.db, belongsTo),
          }).then(() => {
            history.push("/home");
          });
        })
        .catch((e) => {
          console.log("Signup unsuccessful");
        });
    });
  };

  // Vérifier si l'utilisateur est déjà connecté
  useEffect(() => {
    setCurrentUser(firebase.auth.currentUser);
  }, [firebase.auth.currentUser]);

  const laboratoriesRef = collection(firebase.db, "laboratories");
  const [laboratories, setLaboratories] = useState([]);
  useEffect(() => {
    getDocs(laboratoriesRef).then((querySnapshot) => {
      const labs = querySnapshot.docs.map((doc) => ({
        ...doc.data(),
        path: doc.ref.path,
      }));
      setLaboratories(labs);
    });
  }, []);

  console.log(laboratories);

  return (
    <div className={classes.container}>
      <Box className={classes.header}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon style={{ fontSize: 32 }} />
        </Avatar>
        <Typography variant="h3" className={classes.title}>
          Créer un utilisateur
        </Typography>
        <Typography variant="body1" className={classes.subtitle}>
          Ajoutez un nouveau membre à votre équipe
        </Typography>
      </Box>

      <Paper className={classes.card} elevation={0}>
        <FinalForm onSubmit={onSubmit} style={classes.form}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <InputText
                name="firstName"
                label="Prénom"
                required
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <InputText
                name="lastName"
                label="Nom"
                required
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
              />
            </Grid>
          </Grid>

          <InputText
            name="email"
            label="Adresse email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <InputText
            name="password"
            label="Mot de passe"
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <FormControl variant="outlined" className={classes.select}>
            <InputLabel id="status-label">Statut</InputLabel>
            <Select
              labelId="status-label"
              id="status"
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              label="Statut"
              required
            >
              <MenuItem value="hostess">Hôtesse</MenuItem>
              <MenuItem value="technician">Préleveur</MenuItem>
            </Select>
          </FormControl>

          <FormControl variant="outlined" className={classes.select}>
            <InputLabel id="belongs-to-label">Laboratoire</InputLabel>
            <Select
              labelId="belongs-to-label"
              id="belongs-to"
              value={belongsTo}
              onChange={(e) => setBelongsTo(e.target.value)}
              label="Laboratoire"
              required
            >
              <MenuItem value="">Sélectionner un laboratoire</MenuItem>
              {laboratories.map((lab) => (
                <MenuItem key={lab.path} value={lab.path}>
                  {lab.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <CustomButton
            type="submit"
            className={classes.submit}
            title="Créer l'utilisateur"
            fullWidth={true}
          />
        </FinalForm>
      </Paper>

      <Box className={classes.footer}>
        <Typography variant="body2" color="textSecondary">
          {"Copyright © "}
          <Link
            color="primary"
            href="https://gyra-lean.com/"
            style={{ textDecoration: "none", fontWeight: 500 }}
          >
            GYRA
          </Link>{" "}
          {new Date().getFullYear()}
        </Typography>
      </Box>
    </div>
  );
}
